module.exports = __webpack_public_path__ + "static/3Ply-064ec901da23c47e608f93474d0848d5.jpg";